export default [
  'ADDITIONAL_INFORMATION_ARCHIVE',
  'ADDITIONAL_INFORMATION',
  'API_KEYS',
  'ASSESSMENTS',
  'AUDIT_LOGS_GENERAL',
  'AUDIT_LOGS_INTERVIEWS',
  'AUDIT_LOGS_JOBS',
  'AUDIT_LOGS_CAREER_PATHS',
  'AUDIT_LOGS_SIGNOFFS',
  'AUDIT_LOGS_REVIEWS',
  'CANDIDATES',
  'CAREER_PATHS',
  'CERTIFICATION_ARCHIVE',
  'CERTIFICATION',
  'COMPETENCIES',
  'COMPETENCY_ARCHIVE',
  'COMPETENCY_QUESTIONS',
  'DEFINED_CAREER_PATHS',
  'EDUCATION_ARCHIVE',
  'EDUCATION',
  'EXPERIENCES_ARCHIVE',
  'EXPERIENCES',
  'GUIDES',
  'JOB_SIGNOFFS',
  'JOBS_ARCHIVE',
  'JOBS',
  'LANGUAGES_ARCHIVE',
  'LANGUAGES',
  'LEVEL_ANALYSIS_COMPETENCIES',
  'LEVEL_ANALYSIS_SKILLS',
  'OPENINGS',
  'PARTICIPANTS',
  'POSITIONS',
  'RESPONSIBILITIES',
  'RESPONSIBILITY_ARCHIVE',
  'REVIEWS',
  'REVIEW_LEVEL_RESULTS',
  'REVIEW_PERFORMANCE_RESULTS',
  'REVIEW_MANAGER_RESULTS',
  'SKILLS_ARCHIVE',
  'SKILLS',
  'SURVEYS',
  'TASKS',
  'TOPIC_QUESTIONS',
  'USERS',
  'WAREHOUSE_CERTIFICATIONS',
  'WAREHOUSE_COMPETENCIES',
  'WAREHOUSE_EDUCATION',
  'WAREHOUSE_INTERVIEW_QUESTIONS',
  'WAREHOUSE_JOBS',
  'WAREHOUSE_RESPONSIBILITIES',
  'WAREHOUSE_SKILLS',
  'WORKING_CONDITIONS_ARCHIVE',
  'WORKING_CONDITIONS',
  'DRAFT_JOBS',
  'COLLABORATORS',
  'PEOPLE_DATA',
  'PIPELINES',
  'PIPELINE_PEOPLE'
].reduce((acc, cv) => ({ ...acc, [cv]: cv }), {});
